//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global process */
import * as Sentry from '@sentry/browser';
import outside from 'vue-outside';
import HelpIcon from 'gso-design-icons/vue/material-design/help.vue';
import ArrowDropDownIcon from 'gso-design-icons/vue/material-design/arrow_drop_down.vue';
import UserGuideIcon from 'gso-design-icons/vue/user_guide.vue';
import appName from 'gso-app-name';
import userLanguage from 'gso-user-language';
import resolveUrl from '../mixins/resolve-url';
import en from '../../i18n/en.json';
import fr from '../../i18n/fr.json';
import nl from '../../i18n/nl.json';
import isLoggedIn from '../is-logged-in';

const USERGUIDE_BASE = process.env.USERGUIDE || '/userguide';

export default {
	components: {
		HelpIcon,
		ArrowDropDownIcon,
		UserGuideIcon
	},
	directives: {outside},
	mixins: [resolveUrl],
	props: ['helpHref', 'userGuide'],
	data() {
		const oldAppName = window.location.pathname.substring(
			1,
			window.location.pathname.lastIndexOf('/')
		);
		return {
			userGuideUrls: [],
			appName: appName() || oldAppName
		};
	},
	computed: {
		userGuides() {
			return Array.isArray(this.userGuide)
				? this.userGuide
				: [this.userGuide || 'userguide.pdf'];
		},
		isOpen() {
			return this.$store.state.header.isOpen === 'help';
		},
		helpUrl() {
			return this.helpHref && this.resolveUrl(this.helpHref);
		},
		links() {
			const links = [];

			if (this.helpUrl) {
				links.push({name: 'userGuide', url: this.helpUrl, icon: UserGuideIcon});
			}

			this.userGuides
				.filter((userGuide, index) => this.userGuideUrls[index])
				.forEach((userGuide, index) => {
					const label =
						typeof userGuide === 'string' ? userGuide : userGuide.label;
					links.push({
						name: 'userGuide',
						url: this.userGuideUrls[index],
						label: label || this.$t('userGuide'),
						icon: UserGuideIcon
					});
				});

			return links;
		},
		onlyUserguides() {
			return this.links.every(link => link.name === 'userGuide');
		}
	},
	watch: {
		userGuides: {
			immediate: true,
			async handler(userGuides) {
				if (!isLoggedIn()) {
					return;
				}

				let guides = [];
				try {
					const fetched = await fetch(`${USERGUIDE_BASE}/guides.json`);
					guides = await fetched.json();
				} catch (error) {
					console.error(error);
					Sentry.captureException(error);
				}

				const fileNames = userGuides.map(userGuide =>
					typeof userGuide === 'string' ? userGuide : userGuide.filename
				);

				this.userGuideUrls.push(
					...(await Promise.all(
						fileNames.map(fileName =>
							this.getUserGuide(guides, fileName || 'userguide.pdf')
						)
					))
				);
			}
		}
	},
	methods: {
		toggle() {
			if (this.isOpen) {
				this.$store.commit('header/close');
			} else {
				this.$store.commit('header/open', {menu: 'help'});
			}
		},
		outside(event, el) {
			if (el.parentElement && !el.parentElement.contains(event.target)) {
				if (this.isOpen) {
					this.$store.commit('header/close');
				}
			}
		},
		async getUserGuide(guides, file) {
			let guide = guides.find(
				g =>
					g.app === this.appName && g.lang === userLanguage() && g.name === file
			);
			if (!guide) {
				guide = guides.find(
					g => g.app === this.appName && g.lang === userLanguage()
				);
			}

			if (!guide) {
				return null;
			}

			return `${USERGUIDE_BASE}${guide.path}`;
		}
	},
	i18n: {
		messages: {
			fr: fr.help,
			nl: nl.help,
			en: en.help
		}
	}
};
